import { useAtom } from 'jotai';
import { atomWithReducer } from 'jotai/utils';

import { teamReducer, initialState, TeamStateReducer } from '@/store/team';

const atomTeamReducer = atomWithReducer(
  initialState as TeamStateReducer,
  teamReducer
);

export function useTeamStore() {
  const [state, dispatch] = useAtom(atomTeamReducer);

  return { state, dispatch };
}
